import { IPredicateFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { UnreachableCaseError } from 'ts-essentials';
import SimplePredicateContent from './SimplePredicateContent';
import { Fragment } from 'react';
import styled from 'styled-components';

interface IProps {
  predicate: IPredicateFieldsFragment;
  index: number;
}

const Includes = styled.div`
  font-weight: 500;
`;

export default ({ predicate, index }: IProps) => {
  if (predicate.__typename === 'SimplePredicate') {
    return <SimplePredicateContent predicate={predicate} index={index} />;
  } else if (predicate.__typename === 'ArrayObjectPredicate') {
    return (
      <>
        {predicate.elementPredicates.map(
          (elementPredicate, elementPredicateIndex) => {
            return (
              <Fragment
                key={`array-predicate-${index}-element-${elementPredicateIndex}`}
              >
                {elementPredicateIndex > 0 ? (
                  <Includes>, includes </Includes>
                ) : null}
                <SimplePredicateContent
                  predicate={elementPredicate}
                  index={elementPredicateIndex}
                />
              </Fragment>
            );
          },
        )}
      </>
    );
  } else {
    throw new UnreachableCaseError(predicate);
  }
};
